import { EmployeePermission } from 'src/api/permissions';
import { Building, Floor, Town } from 'src/api/types';
import { placeTypeByPermission } from 'src/consts';
import { PlaceType } from 'src/types';

export interface IsBookingAvailableParams {
  placeType: PlaceType;
  building?: Building | undefined;
  floor?: Floor | undefined;
  town?: Town | undefined;
  permissions?: Set<EmployeePermission> | undefined;
}

export const isBookingAvailable = ({
  placeType,
  building,
  floor,
  town,
  permissions,
}: IsBookingAvailableParams): boolean => {
  const requiredPermission = placeTypeByPermission[placeType];

  if (
    !permissions ||
    !permissions.has(requiredPermission) ||
    !floor ||
    !town ||
    !building
  )
    return false;

  const testData = !!(floor.testData || building.testData || town.testData);

  if (testData) return permissions.has(EmployeePermission.QA);

  return !!floor.inheritedEnabled;
};
